const DataCentreMainPage = () => null;
export default DataCentreMainPage;